import React from 'react';
import Helmet from 'react-helmet';
import styled from '@emotion/styled';
import { useLocation } from 'react-router';

import IdntyRegistrationHeader from './components/presentational/IdntyRegistrationHeader';
import RegistrationContainer from './components/containers/RegistrationContainer';
import BackgroundSlidesPageContainer from '../login/components/shared/BackgroundSlidesPageContainer';
import useBackgroundSlides, { createLoginSlides } from '../login/components/hooks/useBackgroundSlides';
import IdntyBackgroundImage from '../../shared/images/idnty-registration-background.png';

const slides = createLoginSlides(12);

const IdntyResponsiveContainer = styled('main')`
  background: ${({ isConfirmation }) => (isConfirmation
    ? '#000'
    : `linear-gradient(180deg, #000 -4.23%, rgba(0, 0, 0, 0.85) 47.91%, #000 100.04%),
       url(${IdntyBackgroundImage}) lightgray 0px -97.7px / 101.253% 117.712% no-repeat`)};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 40px;
  min-height: 100vh;
  width: 100%;
  padding-top: 40px;
  padding-bottom: 40px;
  @media screen and (max-width: 768px) {
    padding-top: 30px;
    padding-bottom: 30px;
  }

  @media screen and (max-width: 425px) {
    padding-bottom: 0;
  }
`;

const ResponsiveContainer = styled(BackgroundSlidesPageContainer)`
  @media screen and (max-width: 768px) {
    padding-top: 30px;
    padding-bottom: 30px;
  }

  @media screen and (max-width: 425px) {
    padding-top: 0;
    padding-bottom: 0;
  }
`;

const Registration = () => {
  const { imageTransition } = useBackgroundSlides(slides);
  const { pathname } = useLocation();
  const helmetTitle = pathname.includes('easy-join') ? 'Easy Join | TeamBuildr' : 'Registration | TeamBuildr';

  if (pathname.includes('/idnty')) {
    const isConfirmation = pathname.includes('/success');
    return (
      <IdntyResponsiveContainer isConfirmation={isConfirmation}>
        <Helmet>
          <title>Registration | IDNTY</title>
        </Helmet>
        <IdntyRegistrationHeader />
        <RegistrationContainer />
      </IdntyResponsiveContainer>
    );
  }

  return (
    <ResponsiveContainer
      alignItems='flex-start'
      as='main'
      fullHeight
      imageHeight='auto'
      imageMinHeight='100%'
      imagePosition='fixed'
      imageTransition={imageTransition}
      imageZIndex='0'
      overflowY='auto'
      paddingBottom='40px'
      paddingTop='40px'
      position='relative'
    >
      <Helmet>
        <title>{helmetTitle}</title>
      </Helmet>
      <RegistrationContainer />
    </ResponsiveContainer>
  );
};

export default Registration;
